export default __webpack_public_path__ + "static/media/sports-icon.8428d52e.svg";